<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->

    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Our Services " subtitle="Our Services"></app-page-banner>
        <!-- INNER PAGE BANNER END -->

        <!-- Project START -->
        <div class="section-full p-t10 p-b90 projects-outer-full">

            <div class="container">

                <!-- TITLE START-->
                <!-- <div class="section-head center wt-small-separator-outer">
                    <div class="wt-small-separator site-text-secondry">
                        <div class="sep-leaf-left"></div>
                        <div>School Mental Health Programs </div>
                    </div>
                    <h2 class="wt-title">Brilliant Ideas With Excellent Work </h2>
                </div> -->
                <!-- TITLE END-->
                
                
                    <div class="s-section">
                        <div class="row">
                            <!-- Service Boxes -->
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-1">
                                    <div class="service-icon-box-image" onclick="toggleContent(1)">
                                        <img src="assets/images/psy.jpg" alt="Psychotherapy Services" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title" onclick="toggleContent(1)">
                                        <h4 class="wt-title">Psychotherapy Services</h4>
                                    </div>
                                    <!-- Hidden content with "Read More" link -->
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>Transform Your Life with Compassionate Psychotherapy.</p> -->
                                        <a routerLink="/psycho-therapy" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-2">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/anth.jpg" alt="Anxiety Disorders Treatment" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Anxiety Disorders Treatment</h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/anxiety" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-3">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/dep.jpg" alt="Depression Treatment" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Depression Treatment
                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/depression-treatment" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-4">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/anger.jpg" alt="Anger Management" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Anger Management</h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/anger-management" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-5">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/ocd.jpg" alt="Obsessive Compulsive Disorder (OCD) Treatment" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Obsessive Compulsive Disorder (OCD) Treatment</h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/ocd" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/ptsd.jpg" alt="Post Traumatic Stress Disorder (PTSD) Treatment
                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Post Traumatic Stress Disorder (PTSD) Treatment
                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/ptsd" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/stress.jpg" alt="Industrial Psychologist
                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Industrial Psychologist
                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/industrial-organizational" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/career.jpg" alt="Career Counseling for Working Professionals
                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Career Counseling for Working Professionals
                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/career-counseling" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/ChildPsychology.jpg" alt="Child Psychology
                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Child Psychology
                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/child-psychology" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/Disability.jpg" alt="Learning Disability (Dyslexia) Treatment

                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Learning Disability (Dyslexia) Treatment

                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/dyslexia" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/SpecialEducation.jpg" alt="SpecialEducation

                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Special Education for Children with Special Needs


                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/special-education" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/MoodDisorders.jpg" alt="Mood Disorders Treatment" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Mood Disorders Treatment



                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/mood-disorders" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/AffectiveandEmotional.jpg" alt="Affective and Emotional Difficulties
                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Affective and Emotional Difficulties
                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/effective-emotional" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/BehaviorsandThought.jpg" alt="Behaviors and Thought Problems
                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Behaviors and Thought Problems
                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Aniety Disorders Treatment.</p> -->
                                        <a routerLink="/behaviors-thought" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/OtherServices.jpg" alt="Other Services
                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Other Services

                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/other-services" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/CorporatWellness.jpg" alt="Corporate Wellness Program

                                        " class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Corporate Wellness Program


                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/corporate-wellness" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/StressManagement.jpg" alt="Stress Management" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Stress Management



                                        </h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/stress-management" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 m-b30">
                                <div class="service-icon-box-two box-color-6">
                                    <div class="service-icon-box-image">
                                        <img src="assets/images/OurInnovativeServices1.jpg" alt="Our Innovative Services" class="service-image">
                                    </div>
                                    <div class="service-icon-box-title">
                                        <h4 class="wt-title">Our Innovative Services</h4>
                                    </div>
                                    <div id="content-box-1" class="content-box">
                                        <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                                        <a routerLink="/innovative-services" class="site-button-link site-text-primary">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                

                                        
                                                  
                    </div>
            </div>
            

        

    </div>
    <!-- Project SECTION END -->

    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>